import { render } from "./SideBarMenu.vue?vue&type=template&id=4172c895"
import script from "./SideBarMenu.vue?vue&type=script&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__